import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { dripiconlist } from "src/helpers/iconList";
import { useAppSelector } from "src/store";
import { getSectors } from "src/store/system/saga";
import { SectorDto } from "src/store/system/type";
import { createAssetGroupSaga } from "src/store/asset-groups/saga";
import * as Yup from "yup";
import { getAssetTypeListSaga } from "src/store/asset-types/saga";
import { AssetTypeDto } from "src/store/asset-types/type";

const AssetGroupCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string, result?: any) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [assetTypes, setAssetTypes] = useState<AssetTypeDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getAssetTypeListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setAssetTypes(payload);
            },
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("AssetGroup.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          Code: "",
          UniversalCode: "",
          MinimumAge: 0,
          MaximumAge: 0,
          AssetTypeId: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Name: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createAssetGroupSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message, payload);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Code: Yup.string().required(t("Validation.Required").toString()),
          Name: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("AssetGroup.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "AssetTypeId",
            label: t("AssetGroup.AssetType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: assetTypes,
            },
          },
          {
            field: "Code",
            label: t("AssetGroup.Code").toString(),
            col: 6,
          },
          {
            field: "UniversalCode",
            label: t("AssetGroup.UniversalCode").toString(),
            col: 6,
          },
          {
            field: "MinimumAge",
            label: t("AssetGroup.MinimumAge").toString(),
            col: 6,
            type: "number",
          },
          {
            field: "MaximumAge",
            label: t("AssetGroup.MaximumAge").toString(),
            col: 6,
            type: "number",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AssetGroupCreateForm;
